import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../utils/api';

const GeoContext = createContext(null);

export const useGeo = () => useContext(GeoContext);

const OVERRIDE_KEY = 'preferred_currency';

export const GeoProvider = ({ children }) => {
  const [detected, setDetected] = useState({
    country_code: 'GB',
    country_name: 'United Kingdom',
    // rate = units of currency per 1 GBP (GBP is the base/canonical currency)
    currency: { code: 'GBP', symbol: '£', rate: 1.0 },
    phone_code: '+44',
    detected: false
  });
  const [currencies, setCurrencies] = useState([{ code: 'GBP', symbol: '£', rate: 1.0 }]);
  const [override, setOverride] = useState(() => localStorage.getItem(OVERRIDE_KEY) || null);

  useEffect(() => {
    axios.get(`${API}/geo/detect`)
      .then(res => { if (res.data.success) setDetected({ ...res.data, detected: true }); })
      .catch(() => {});
    axios.get(`${API}/currencies`)
      .then(res => { if (res.data.success && res.data.currencies?.length) setCurrencies(res.data.currencies); })
      .catch(() => {});
  }, []);

  // Effective display currency: manual override (if valid) > detected > GBP.
  const overrideCur = override ? currencies.find(c => c.code === override) : null;
  const currency = overrideCur || detected.currency || { code: 'GBP', symbol: '£', rate: 1.0 };

  const setCurrency = (code) => {
    setOverride(code);
    if (code) localStorage.setItem(OVERRIDE_KEY, code);
    else localStorage.removeItem(OVERRIDE_KEY);
  };

  // Format a GBP amount into the visitor's chosen/local currency for DISPLAY.
  const format = (gbpAmount) => {
    const n = parseFloat(gbpAmount) || 0;
    const local = n * (currency.rate || 1);
    const decimals = (currency.rate >= 100) ? 0 : 2;
    return `${currency.symbol}${local.toFixed(decimals)}`;
  };

  return (
    <GeoContext.Provider value={{
      ...detected,
      currency,
      currencies,
      setCurrency,
      format
    }}>
      {children}
    </GeoContext.Provider>
  );
};
